document.addEventListener('DOMContentLoaded', function () {
  initRevealScroll();
  initCifrasAnimadas();
  initFaq();
  initComparador();
  initGaleriaProducto();
  initVariantesProducto();
});

/* Revela elementos .mt-reveal al entrar en pantalla, con stagger por contenedor */
function initRevealScroll() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = el.getAttribute('data-mt-delay') || 0;
      setTimeout(function () { el.classList.add('mt-visible'); }, Number(delay));
      observer.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  els.forEach(function (el) { observer.observe(el); });
}

/* Cuenta ascendente para .mt-cifra__num[data-hasta] */
function initCifrasAnimadas() {
  var nums = document.querySelectorAll('.mt-cifra__num[data-hasta]');
  if (!nums.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      observer.unobserve(el);
      if (reduce) { el.textContent = hasta + sufijo; return; }

      var inicio = performance.now();
      var duracion = 1400;
      function paso(ahora) {
        var t = Math.min(1, (ahora - inicio) / duracion);
        var ease = 1 - Math.pow(1 - t, 3);
        var valor = Math.round(hasta * ease);
        el.textContent = valor + sufijo;
        if (t < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });

  nums.forEach(function (el) { observer.observe(el); });
}

/* Acordeón de preguntas frecuentes */
function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  if (!items.length) return;

  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;

    boton.addEventListener('click', function () {
      var abierta = item.getAttribute('data-abierto') === 'true';
      items.forEach(function (otro) {
        otro.setAttribute('data-abierto', 'false');
        otro.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierta) {
        item.setAttribute('data-abierto', 'true');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

/* Comparador antes/después con deslizador arrastrable */
function initComparador() {
  var marcos = document.querySelectorAll('.mt-comparador__marco');
  marcos.forEach(function (marco) {
    var despues = marco.querySelector('.mt-comparador__despues');
    var despuesImg = despues ? despues.querySelector('img') : null;
    var handle = marco.querySelector('.mt-comparador__handle');
    if (!despues || !despuesImg || !handle) return;

    var arrastrando = false;

    function fijarAnchoImagen() {
      despuesImg.style.width = marco.getBoundingClientRect().width + 'px';
    }
    fijarAnchoImagen();
    window.addEventListener('resize', fijarAnchoImagen);

    function mover(clienteX) {
      var rect = marco.getBoundingClientRect();
      var x = Math.min(rect.width, Math.max(0, clienteX - rect.left));
      var porcentaje = (x / rect.width) * 100;
      despues.style.width = porcentaje + '%';
      handle.style.left = porcentaje + '%';
    }

    marco.addEventListener('pointerdown', function (e) { arrastrando = true; mover(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    marco.addEventListener('touchstart', function (e) { if (e.touches[0]) mover(e.touches[0].clientX); }, { passive: true });
    marco.addEventListener('touchmove', function (e) { if (e.touches[0]) mover(e.touches[0].clientX); }, { passive: true });
  });
}

/* Miniaturas de la galería de producto */
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-producto-media__principal img');
    var minis = galeria.querySelectorAll('.mt-producto-media__mini');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-src');
        var srcset = mini.getAttribute('data-srcset');
        var alt = mini.getAttribute('data-alt') || '';
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        principal.alt = alt;
        minis.forEach(function (m) { m.setAttribute('data-activa', 'false'); });
        mini.setAttribute('data-activa', 'true');
      });
    });
  });
}

/* Selector de variantes: actualiza precio, id oculto y estado agotado */
function initVariantesProducto() {
  var formularios = document.querySelectorAll('[data-mt-form-producto]');
  formularios.forEach(function (form) {
    var datosEl = form.querySelector('[data-mt-variantes]');
    if (!datosEl) return;
    var variantes;
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var pills = form.querySelectorAll('.mt-producto-compra__pill');
    var inputId = form.querySelector('input[name="id"]');
    var botonAnadir = form.querySelector('.mt-producto-compra__anadir');
    var precioActual = form.querySelector('.mt-producto-compra__precio-actual');
    var precioAntes = form.querySelector('.mt-producto-compra__precio-antes');
    var seleccion = {};

    pills.forEach(function (pill) {
      if (pill.getAttribute('data-seleccionada') === 'true') {
        seleccion[pill.getAttribute('data-opcion')] = pill.getAttribute('data-valor');
      }
    });

    function money(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
    }

    function actualizar() {
      var variante = variantes.find(function (v) {
        return v.selectedOptions ? v.selectedOptions.every(function (o) { return seleccion[o.name] === o.value; })
          : v.options.every(function (val, i) { return Object.values(seleccion)[i] === val; });
      });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioActual && variante.price) precioActual.textContent = money(variante.price);
      if (precioAntes) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntes.textContent = money(variante.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      if (botonAnadir) {
        botonAnadir.disabled = !variante.available;
        botonAnadir.querySelector('[data-mt-texto-boton]').textContent = variante.available
          ? botonAnadir.getAttribute('data-texto-disponible')
          : botonAnadir.getAttribute('data-texto-agotado');
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var grupo = pill.getAttribute('data-opcion');
        form.querySelectorAll('.mt-producto-compra__pill[data-opcion="' + grupo + '"]').forEach(function (p) {
          p.setAttribute('data-seleccionada', 'false');
        });
        pill.setAttribute('data-seleccionada', 'true');
        seleccion[grupo] = pill.getAttribute('data-valor');
        actualizar();
      });
    });

    actualizar();
  });
}
